// removed by extract-text-webpack-plugin
module.exports = {"form":"OkR2Dck9iA","formGroupLeft":"_3MAbG1EF_N","formGroupRight":"_3gliaGzIi0"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/forms/public/ReferForm/ReferForm.module.less
// module id = 987
// module chunks = 3